import React from "react";

import { Badge } from "@mantine/core";

import { ideaTypeColorMap } from "modules/ideas/utils/constants";

import { IdeaType } from "modules/ideas/types/entities";

interface IProps {
  label?: string;
  type: IdeaType;
}

const labelMap: Record<IdeaType, string> = {
  StoryHypothesis: "Hypothesis",
  StoryTesting: "Testing",
  StoryIdea: "Ideas"
};

const IdeaTypeChip: React.FC<IProps> = props => {
  const { type, label } = props;

  return (
    <Badge
      variant="outline"
      tt="capitalize"
      size="xs"
      color={ideaTypeColorMap[type]}
    >
      {label || labelMap[type]}
    </Badge>
  );
};

export default IdeaTypeChip;
